import { useState, useEffect } from 'react';
import { collection, getDocs, query, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../../firebase/config';

interface TickerProject {
  id: string;
  name: string;
  budget: number;
  timeline: string;
}

const ProjectTicker = () => {
  const [projects, setProjects] = useState<TickerProject[]>([]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const q = query(
          collection(db, 'projects'),
          where('status', '==', 'active'),
          orderBy('createdAt', 'desc'),
          limit(10)
        );
        const snap = await getDocs(q);
        setProjects(
          snap.docs.map(d => {
            const data = d.data();
            return {
              id: d.id,
              name: data.name || '',
              budget: data.budget || 0,
              timeline: data.timeline || '',
            };
          })
        );
      } catch {
        // silently fail — ticker is non-critical
      }
    };
    fetch();
  }, []);

  if (projects.length < 2) return null;

  const doubled = [...projects, ...projects];

  return (
    <div
      style={{
        width: '100%',
        maxWidth: '1280px',
        margin: '2rem auto',
        background: '#ffffff',
        border: '1px solid #e5e5e5',
        borderRadius: '12px',
        overflow: 'hidden',
      }}
    >
      {/* Header row */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '14px 20px',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#ea4c3c',
              display: 'inline-block',
              animation: 'ticker-dot-pulse 1.5s ease-in-out infinite',
            }}
          />
          <span
            style={{
              fontSize: '12px',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              color: '#6b7280',
              fontWeight: 600,
            }}
          >
            Projets en cours
          </span>
        </div>
        <span style={{ fontSize: '12px', color: '#9ca3af' }}>
          Mis à jour en temps réel
        </span>
      </div>

      {/* Scrolling strip */}
      <div style={{ overflow: 'hidden' }}>
        <div
          className="ticker-strip"
          style={{
            display: 'flex',
            gap: '12px',
            padding: '14px 20px',
            width: 'max-content',
          }}
        >
          {doubled.map((p, i) => (
            <div
              key={`${p.id}-${i}`}
              style={{
                width: '240px',
                flexShrink: 0,
                background: '#f9f9f9',
                border: '1px solid #e5e5e5',
                borderRadius: '8px',
                padding: '12px 14px',
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
              }}
            >
              <p
                style={{
                  fontSize: '13px',
                  fontWeight: 500,
                  color: '#111827',
                  margin: 0,
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  lineHeight: '1.4',
                }}
              >
                {p.name}
              </p>
              <span
                style={{
                  alignSelf: 'flex-start',
                  border: '1px solid #ea4c3c',
                  color: '#ea4c3c',
                  fontSize: '11px',
                  padding: '2px 8px',
                  borderRadius: '4px',
                  fontWeight: 600,
                }}
              >
                {p.budget.toLocaleString('fr-FR')} €
              </span>
              <p style={{ fontSize: '11px', color: '#9ca3af', margin: 0 }}>
                Délai : {p.timeline}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Footer row */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '10px 20px',
          borderTop: '1px solid #e5e5e5',
        }}
      >
        <span style={{ fontSize: '12px', color: '#6b7280' }}>
          Vous avez un projet ? Publiez-le gratuitement.
        </span>
        <a
          href="/register"
          style={{
            fontSize: '12px',
            fontWeight: 600,
            color: '#ffffff',
            backgroundColor: '#ea4c3c',
            padding: '6px 14px',
            borderRadius: '6px',
            textDecoration: 'none',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#d43f30')}
          onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#ea4c3c')}
        >
          S'inscrire →
        </a>
      </div>
    </div>
  );
};

export default ProjectTicker;
